import React from "react";
import { HashLink } from "react-router-hash-link";
import "../Footer/Footer.css";
import logo from "../assets/logo.png"
// Import React Icons
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter, FaLinkedinIn, FaGoogle } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Logo */}
        <div className="footer-logo">
          <img
            src={logo}
            alt="Big Feathers Logo"
          />
        </div>

        {/* Contact Details */}
        <div className="footer-contact">
          <h3>Contact Details</h3>
          <p>
            <a href="mailto:info@ignite.org.in">
              📧  digitalignite43@gmail.com
            </a>
          </p>
        
          <p>
            <a href="tel:+918527472989">📞 +91 – 8527472989</a>
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
         <ul>
  <li><a href="#home">Home</a></li>
  <li><a href="#about">About</a></li>
  <li><a href="#company-profile">Company Profile</a></li>
    <li><a href="#projects">Key Projects</a></li>
  <li><a href="#contact">Contact</a></li>

</ul>
        </div>

        {/* Social Icons */}
        <div className="footer-social">
          <h3>Follow Us On</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/ignite.digit?igsh=NnB3bjlvdnB1M25m" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.facebook.com/share/1CdGV46Y8H/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/in/ignite-technologies-a40277b6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 <strong>IgniteDigit</strong> | Powered by <strong>IgniteDigit</strong></p>
      </div>
    </footer>
  );
};

export default Footer;
